/**
 * Shared chart color palettes for Recharts components.
 * Sourced from Neeve DLS color scales (bitbucket.org/iotium/dls-neeve).
 * Import from here instead of defining local color arrays per file.
 */

/** 10-color palette for pie/donut charts and general multi-series charts */
export const PIE_COLORS = [
  '#065545',  // green-900 (neeve-primary)
  '#012a22',  // green-950 (neeve-secondary)
  '#03795e',  // green-700
  '#68c2de',  // blue-300 (brand-tertiary)
  '#268fb4',  // blue-500 (brand-secondary)
  '#225e7c',  // blue-700 (brand-primary)
  '#ff9038',  // orange-400
  '#f5c16a',  // amber-300 (sara-primary)
  '#2f8a77',  // neeve-tertiary
  '#33d4a3',  // green-400
];

/** 10-color palette for bar charts */
export const BAR_COLORS = [
  '#065545',  // green-900 (neeve-primary)
  '#012a22',  // green-950 (neeve-secondary)
  '#03795e',  // green-700
  '#68c2de',  // blue-300 (brand-tertiary)
  '#268fb4',  // blue-500 (brand-secondary)
  '#225e7c',  // blue-700 (brand-primary)
  '#ff9038',  // orange-400
  '#f5c16a',  // amber-300 (sara-primary)
  '#2f8a77',  // neeve-tertiary
  '#33d4a3',  // green-400
];
